import React, { MouseEventHandler, ReactElement } from 'react';

import ExclamationMark from '@/components/commons/icons/ExclamationMark';

interface Props {
    readonly onClick: MouseEventHandler;
    readonly text?: string;
    readonly externalStyles?: string;
    readonly icon?: ReactElement;
}

function BioHelpLink({
    onClick,
    text = 'Help, this bio is total nonsense!',
    externalStyles = '',
    icon = <ExclamationMark className="w-4 h-4 float-left mr-[2px] text-progressBarBlue" />,
}: Props) {
    return (
        <button
            onClick={onClick}
            type="button"
            className={`flex items-center gap-1 ${externalStyles}`}
        >
            {icon}
            <span className="text-progressBarBlue font-instrument text-[14px] leading-21">{text}</span>
        </button>
    );
}

export default BioHelpLink;
